import { commandCenterPricingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_RATE_SHEET_MOVEMENT_ACTION_TYPE = createNamedActions(
  'commandCenterRateSheetMovement',
  {
    SET_RATE_SHEET_MOVEMENT: 'SET_RATE_SHEET_MOVEMENT',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterRateSheetMovementAction = catchAsyncActionError(
  () => async dispatch => {
    try {
      const data = await fetchSafe(() =>
        commandCenterPricingApi.getRateSheetMovement({ config: SKIP_FORBIDDEN_CONFIG }),
      );

      dispatch({
        type: COMMAND_CENTER_RATE_SHEET_MOVEMENT_ACTION_TYPE.SET_RATE_SHEET_MOVEMENT,
        payload: data,
      });
    } finally {
      // In a `finally` so the slice is marked loaded even when a swallowed 403
      // degrades to null — otherwise the zone skeleton never clears.
      dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.RATE_SHEET_MOVEMENT));
    }
  },
);
